export default (_, inject) => {
  inject('utils', {})
}
